export default {
    move_to_other_account_title: "Move to another account",
    move_to_other_account_account_from: "Account From",
    move_to_other_account_account_to: "Account To",
    move_to_other_account_devices: "Devices",
    move_to_other_account_input: "IMEI or Serial",
    move_to_other_account_imei: "IMEI",
    move_to_other_account_serial: "Serial",
    move_to_other_account_model: "Model",
    move_to_other_account_change: "Move",
    move_to_other_account_no_devices_added: "No devices added",
    move_to_other_account_device_is_already_added: "The device is already added",
    move_to_other_account_device_has_not_been_found: "The device has not been found",
    move_to_other_account_this_feature_is_not_available: "This feature is not available",
    move_to_other_account_single_success_message: "The device has been moved",
    move_to_other_account_multiple_success_message: "The devices has been moved",
    move_to_other_account_error_message: "Unable to move the devices due to an error",
    move_to_other_account_select_to_account: "Select the account destination first",
    move_to_other_account_restriction_to_move: "You cannot move active devices to accounts that are not active",
    move_to_other_account_transaction_message: "The request to move the devices has been sent successfully, please check the transactions list to see the status of the request.",
}

